import {
  DAY_RESOLUTION,
  DECADE_RESOLUTION,
  MINUTE_RESOLUTION,
  MONTH_RESOLUTION,
  SECOND_RESOLUTION,
  WEEK_RESOLUTION,
  YEAR_RESOLUTION,
} from './resolution';
import { CalendarPeriodName, CalendarResolution, DatePickerUnit } from './types';

/**
 * 지정된 시간 단위에 대해 DatePicker가 어떤 동작을 해야 하는지 지정하는 객체입니다.
 */
export interface DatePickerUnitConfig {
  resolution: CalendarResolution;
  period: CalendarPeriodName;
  calendarResolution?: CalendarResolution;
  format: string;
  showTimeInput?: boolean;
  /**
   * DatePicker가 단일 날짜를 선택하는 경우더라도 range를 노출해야 하는지 여부를 지정합니다.
   */
  showRange?: boolean;
  /**
   * 사용자가 날짜에 호버했을 때, 해당 인터벌에 해당하는 모든 날짜들에 대해 하이라이트가 필요한지 지정합니다.
   */
  showAllHoverTarget?: boolean;
  /**
   * 날짜 선택시 시간 정보를 유지해야 하는지 지정합니다.
   */
  keepOffset?: boolean;
}

export const DATE_PICKER_UNIT_CONFIGS: Record<DatePickerUnit, DatePickerUnitConfig> = {
  decade: {
    resolution: DECADE_RESOLUTION,
    period: 'decade',
    format: 'yyyy',
    showRange: true,
    keepOffset: false,
  },
  year: {
    resolution: YEAR_RESOLUTION,
    period: 'year',
    format: 'yyyy',
    keepOffset: false,
  },
  month: {
    resolution: MONTH_RESOLUTION,
    period: 'month',
    format: 'yyyy.MM',
    keepOffset: false,
  },
  week: {
    resolution: WEEK_RESOLUTION,
    period: 'day',
    format: 'yyyy.MM.dd',
    showRange: true,
    showAllHoverTarget: true,
    keepOffset: false,
  },
  day: {
    resolution: DAY_RESOLUTION,
    period: 'day',
    format: 'yyyy.MM.dd',
    keepOffset: false,
  },
  minute: {
    resolution: MINUTE_RESOLUTION,
    period: 'day',
    calendarResolution: DAY_RESOLUTION,
    format: 'yyyy.MM.dd HH:mm',
    showTimeInput: true,
    keepOffset: true,
  },
  second: {
    resolution: SECOND_RESOLUTION,
    period: 'day',
    calendarResolution: DAY_RESOLUTION,
    format: 'yyyy.MM.dd HH:mm:ss',
    showTimeInput: true,
    keepOffset: true,
  },
};
